export const api = {
  deviceMan: {
    getAreaConfigTree: '/cms/configtree/queryAreaConfigTree.json',//区域管理-区域配置，查询区域配置树
    getDeviceConfigList: '/cms/configtree/queryDeviceConfigList.json',//查询设备配置列表
    updateConfig: '/cms/configtree/updateConfigTree.json',//修改区域配置
  }
}